import { createFileRoute, Outlet } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";

/** The layout under `/ws/amy`, every screen of Amy's: guarded by her module's own entry
 * (`amy:read`). */
export const Route = createFileRoute("/_authenticated/ws/amy")({
  beforeLoad: ({ context }) => guardRoute(context.me, "move-in-agent"),
  component: Outlet,
});
